import { GraphColor, LocalGraphColour } from "../Colors";
import { TERMS } from "../../../config/terminology";

import { API_URL as api } from "@/config/env";

export const urls = {
	userCountries: `${api}GetUserCountries?`,
	quotaStatus: `${api}Approval/GetScenarioStatus`,
	periods: `${api}Approval/GetPeriods`,
	quotaForApproval: `${api}Approval/GetQuotaforApproval`,
	quotaCustomerBreakdown: `${api}Approval/GetQuotaCustomerBreakdown?`,
	approve: `${api}Approval/ApproveQuota`,
	approveQuotaWithComments : `${api}Approval/ApproveQuotaWithComments`,
	reject: `${api}Approval/RejectQuota`,
   popupGraphData: `${api}ApprovalQuotaModification/GetPopUpGraphData?`,
   lockUnlockQuota: `${api}Approval/LockUnlockQuota`,
   approveMultiple: `${api}Approval/ApproveQuotaMultiple`,
   lockUnlockMultiple: `${api}Approval/LockUnlockQuotaMultiple`,
   rejectMultiple: `${api}Approval/RejectQuotaMultiple`,
   approveMulWithComment: `${api}Approval/ApproveQuotaWithCommentsMultiple`,
   Downloadfile: `${api}Define/DownloadFile?`,
   Upload : `${api}Approve/Upload`,
};

export function getQuotaForApprovalTable(data) {
	const rows = getQuotaForApprovalRow(data);
	for(let i = 0; i < rows.length; i++) {
		rows[i] = getApproveStatus(rows[i]);
	}
	return { rows };
}

function getQuotaForApprovalRow(data) {
	const rows = data.map((item, index) => {
		return {
			id: index,
			quotaId: item.quotaId,
         	scenarioId: item.scenarioId,
			scenarioName: item.scenarioName,
			geoId: item.geoId,
			criticalityId: item.criticalityId,
			graph: item.graph,
			quotaStatus: item.quotaStatus,
			initialForecast: item.initialForecast,
			totalForecast: item.totalForecast,
			previousTotalForecast: item.previousTotalForecast,
			difference: item.difference,
			depletion: item.depletion,
			previousDepletion: item.previousDepletion,
			lastActionDate: item.lastActionDate,
			lastActionBy: item.lastActionBy,
			period: item.period,
			rejectComments: item.rejectComments,
			approveComments: item.approveComments,
			isSubmitLocked: item.isSubmitLocked,
			edit: item.scenarioName,
			revisedQuota: item.revisedQuota,
		};
	});
	return rows;
}

export function getQuotaDetailsTable(data) {
	const columns = getQuotaDetailsColumn();
	const rows = getQuotaDetailsRow(data);
	return { columns, rows };
}

function getQuotaDetailsColumn() {
	const width = 150;
	const columns = [
		{ field: "customerName", headerName: "Customer / CG", width: width },
		{ field: "customerNumber", headerName: "Customer Number", width: width },
		{ field: "skuName", headerName: "SKU / PG", width: width },
		{ field: "skuNumb", headerName: "SKU Number", width: width },
		{ field: "initialQuota", headerName: `Initial ${TERMS.QUOTA}`, width: width },
		{ field: "safetyMargin", headerName: "Safety Margin", width: width },
		{ field: "tender", headerName: "Tender", width: width },
		{ field: "adjustment", headerName: "Adjustment", width: width },
		{ field: "totalQuota", headerName: `Total ${TERMS.QUOTA}`, width: width },
		{ field: "weekly1", headerName: "Week 1", width: width },
		{ field: "weekly2", headerName: "Week 2", width: width },
		{ field: "weekly3", headerName: "Week 3", width: width },
		{ field: "weekly4", headerName: "Week 4", width: width },
		{ field: "weekly5", headerName: "Week 5", width: width },
		{
			field: "customerQuotaComments",
			headerName: `Customer ${TERMS.QUOTA} Comments`,
			width: width,
		},
	];
	return columns;
}

function getQuotaDetailsRow(data) {
	const rows = data.map((item, index) => {
		return {
			id: index,
			customerName: item.customerName,
			customerNumber: item.customerNumber,
			skuName: item.skuName,
			skuNumb: item.skuNumb,
			initialQuota: item.initialQuota,
			safetyMargin: item.safetyMargin,
			tender : item.tender,
			adjustment: item.adjustment,
			totalQuota: item.totalQuota,
			weekly1: item.weekly1,
			weekly2: item.weekly2,
			weekly3: item.weekly3,
			weekly4: item.weekly4,
			weekly5: item.weekly5,
			customerQuotaComments: item.customerQuotaComments,
		};
	});
	return rows;
}
function  getApproveStatus (item){
	let quotaStatus = item.quotaStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
	}
	else {
		if (quotaStatus == "approved" || quotaStatus == "rejected" || quotaStatus == "draft") {
		item['canApproveReject'] = false;
		}
		else {
		if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
			if (quotaStatus == "submitted" || quotaStatus == "locally approved") {
			item['canApproveReject'] = true;
			}
		}
		else if (!logedUser.isHQUser) {
			if (quotaStatus == "submitted") {
			item['canApproveReject'] = true;
			}
			else if (quotaStatus == "locally approved") {
			item['canApproveReject'] = false;
			}
		}
		}
	}
	return item;
  }

export function preparePopupGraphData(data) {
   // The api returns last 20 months data for each data source. So first 20 items are 
   // unique months
   const periods = data.slice(0, 20).map(item => item.period);
   const seriesData = [];
   const dataSourcesSet = new Set(data.map(item => JSON.stringify({
    dataSourceName: item.dataSourceName,
    datasourceID: item.datasourceID
	})));

	const dataSources = Array.from(dataSourcesSet).map(item => JSON.parse(item));
   let start = 0, end = 20;
   for(let d = 0; d < dataSources.length; ++d) {
      const dataSource = dataSources[d].dataSourceName;
      let values = [];
      for(let j = start; j < end; ++j) {
		let s = data[j].value;
          if (s === "null") {
             s = null;
          } else if (
             s === 0
          ) {
             s = null;
          }
        values.push(s);
      }
      seriesData.push( { name: dataSource, data: values, } );
      start += 20;
      end += 20;
   }
	const duplicateDSForColor = data.map(item => ({
		dataSourceName: item.dataSourceName,
		datasourceID: item.datasourceID
	}));
   	const uniqueSet = new Set(duplicateDSForColor.map(JSON.stringify));
	const dsr = Array.from(uniqueSet).map(JSON.parse);
   	const color = [];
   	for(let i = 0; i < dsr.length; ++i) {
		if(dsr[i].dataSourceName.toLowerCase().includes('ex-factory')){
			color.push(GraphColor["Ex-Factory"]);
		}
		else if(dsr[i].dataSourceName.toLowerCase().includes('iqvia - midas')){
			color.push(GraphColor["IQVIA - MIDAS"]);
		}
		else if(dsr[i].dataSourceName.toLowerCase().includes('xyz - system2')){
			color.push(GraphColor["xyz - system2"]);
		}		
		else if (dsr[i].dataSourceName.toLowerCase().includes("financial forecast")) {
			color.push(GraphColor["Financial Forecast"]);
		}
		else if (dsr[i].dataSourceName.toLowerCase().includes("supply chain forecast")) {
			color.push(GraphColor["Supply Chain Forecast"]);
		} 
		else if (dsr[i].dataSourceName.toLowerCase().includes("ai forecast")) {
			color.push(GraphColor["AI Forecast"]);
		}
		else if(dsr[i].dataSourceName.toLowerCase().includes('forecast')){
			color.push(GraphColor.Forecast);
		}
		else if(dsr[i].dataSourceName.toLowerCase().includes('quota')){
			color.push(GraphColor.Quota);
		}
		// else if(dsr[i].dataSourceName.toLowerCase().includes('le diagnostics')){
		// 	color.push(GraphColor.LE);
		// }
		else if(dsr[i].dataSourceName.toLowerCase().includes('sit')){
			color.push(GraphColor.SIT);
		 }
		 else if(dsr[i].datasourceID > 5 && dsr[i].datasourceID < 50){
			color.push(LocalGraphColour[dsr[i].datasourceID]);
		}else{
			color.push("#16d620");
		}
   	}

   const graphData = { periods, seriesData,color };
   console.log("Approval_Quota_preparePopupGraphData", graphData);
   return graphData;
}
